/** Contiene las propiedades básicas para manejar un perfil */
export class BaseProfile {
  /** Nombre */
  Name: string;
  /** Apellidos */
  Surname: string;
  /** Correo electrónico */
  Email: string;
  AdminEmail: string;
  /** Contraseña */
  Password: string;
  /** Documento identificativo */
  Nif: string;
  /** Departamento */
  Department: string;
  /** Teléfono */
  PhoneNumber: string;
}